/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGift = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7.5 4a1.5 1.5 0 1 0 0 3h3.465A3.501 3.501 0 0 0 7.5 4zM11 9H4v2h7zm0 4H4v7h7zm2 7h7v-7h-7zm7-9V9h-7v2zm-.337-4H22v15H2V7h2.337A3.5 3.5 0 0 1 7.5 2c1.86 0 3.505.924 4.5 2.337A5.494 5.494 0 0 1 16.5 2a3.5 3.5 0 0 1 3.163 5zm-6.628 0H16.5a1.5 1.5 0 1 0 0-3 3.501 3.501 0 0 0-3.465 3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGift as Gift };
